module.exports = __webpack_public_path__ + "img/DSC_0061.ea8fc937.jpg";